export const ru = {
    choose_goal: 'Выберите цель',
    conf: 'Конференция',
    goal: 'Цель',
    trip: 'Командировка',
};
